export default {
  'get-list': {
    method: 'post',
    url: '/p/vehicle/category/list'
  },
  getAll: {
    method: 'post',
    url: '/p/vehicle/category/get-all'
  },
  getAllList: {
    method: 'get',
    url: '/p/vehicle/category/list'
  },
  add: {
    method: 'post',
    url: '/p/vehicle/category'
  },
  delete: {
    url: '/p/vehicle/category',
    method: 'delete'
  },
  getById: {
    url: '/p/vehicle/category/ID',
    method: 'get'
  },
  edit: {
    url: '/p/vehicle/category/ID',
    method: 'put'
  },
  find: {
    method: 'get',
    url: '/p/vehicle/category/find?key=KEY&vehicleLoad=vehicleLoadData&QUERY'
  },
  'find-by-vehicle-tonnage': {
    method: 'get',
    url: '/p/vehicle/category/find-by-vehicle-tonnage?key=KEY'
  },
  lastCategory: {
    method: 'get',
    url: '/p/vehicle/category/last-category'
  }
}
